import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { mapData } from '../datamapper';
import { useAuth } from "./authcontext";
import { ShopContext } from './shopinfo';
import '../warenkorb.css'

import { useCart } from './context4cart';

const Warenkorb = () => {

        const { sqlID, callerID, sessionID} = useParams();
        const [confirmDeleteId, setConfirmDeleteId] = useState(null);
        const { setCartItemCount } = useCart();
        const { warenkorb, fetchWarenkorb, updateCartItem, cartItemCount } = useCart();

        const [openRabattId, setOpenRabattId] = useState(null);
        const [totalAmount, setCartTotalAmount] = useState(null);
        const { pgid} = useContext(ShopContext);

        const {user} = useAuth();

       

        //NexusSelect
        const [covers, setCovers] = useState({});
        const [meldetexte, setMeldetexte] = useState({});

      
        const [productinfo, setProductinfo] = useState({});

        //OLA
        const [availability, setAvailability] = useState({});
        const [loading, setLoading] = useState(false);
        const [lastChecked, setLastChecked] = useState(null);

        //Warenkorb Edit
        const [editing, setEditing] = useState({});
               //Struktur:  { [wk_id]: { field: 'menge' | 'bestellzeichen' | null } }
        const [values, setValues] = useState({});
               //Struktur: { [wk_id]: { menge: number, bestellzeichen: string } }

        const [saving, setSaving] = useState({});

     



        const toggleEdit = (wk_id, field, currentValue) => {
                setEditing(prev => ({
                  ...prev,
                  [wk_id]: { field }
                }));
                setValues(prev => ({
                  ...prev,
                  [wk_id]: { 
                    ...prev[wk_id], 
                    [field]: currentValue 
                  }
                }));
          };       


          const handleChange = (wk_id, field, newValue) => {
            setValues(prev => ({
              ...prev,
              [wk_id]: {
                ...prev[wk_id],
                [field]: newValue
              }
            }));
          };
          

          
/*
          const saveChange = async (wk, field) => {
            const wk_id = wk.wk_id;
            const newValue = values[wk_id]?.[field];
        
            setSaving((prev) => ({ ...prev, [wk_id]: true }));
        
            try {
              // "field" is the field "value" = newValue
              const extraParams = {
                knr: wk.knr,
                mitmeta: "true",
                //vormerker: "",
                
                ...(field === "menge" ? { menge: newValue } : {}),
                ...(field === "bestellzeichen" ? { bestellzeichen: newValue } : {}),
                ...(field === "vormerker" ? { vormerker: newValue } : {}),
              };
        
              const text = await updateCartItem(wk_id, field, newValue, extraParams);
        
              if (text && typeof text === "string" && !text.includes("success: true")) {
                console.warn("Server didn’t confirm update, re-syncing:", text);
                await fetchWarenkorb();
              }
            } catch (err) {
              console.error("Network error:", err);
              await fetchWarenkorb(); 
            } finally {
              setSaving((prev) => ({ ...prev, [wk_id]: false }));
              setEditing((prev) => ({
                ...prev,
                [wk_id]: { field: null },
              }));
            }
          };*/

          const saveChange = async (wk, field, overrideValue) => {
            const wk_id = wk.wk_id;
            const newValue = overrideValue ?? values[wk_id]?.[field];
          
            setSaving((prev) => ({ ...prev, [wk_id]: true }));
          
            try {
              const extraParams = {
                knr: wk.knr,
                mitmeta: "true",
              };
          
              if (field === "vormerker") extraParams.vormerker = newValue;
              if (field === "menge") extraParams.menge = newValue;
              if (field === "bestellzeichen") extraParams.bestellzeichen = newValue;
          
              console.log("UPDATE cart item", { wk_id, field, newValue, extraParams });
          
              const text = await updateCartItem(wk_id, field, newValue, extraParams);
          
              if (text && typeof text === "string" && !text.includes("success: true")) {
                await fetchWarenkorb();
              }
            } catch (err) {
              console.error(err);
              await fetchWarenkorb();
            } finally {
              setSaving((prev) => ({ ...prev, [wk_id]: false }));
              setEditing((prev) => ({ ...prev, [wk_id]: { field: null } }));
            }
          };
                
                
            const toggleRabatt = (wk_id) => {
              setOpenRabattId(prev =>
                  prev === wk_id ? null : wk_id
                );
              }
          

        const handleSendCart = async () => {
          // Construct the endpoint URL
         
          const url = `/api-wk-senden/${user.aml}/${user.pgid}/${user.session_id}/`;

        
          fetch(url)
            .then(res => res.text()) //  text instead of JSON
            .then(data => {
              console.log('Backend response:', data);
      
              alert(`Der Warenkorb wurde erfolgreich abgesendet`);
              fetchWarenkorb();
            })
            .catch(err => {
              console.error('Error sending cart:', err);
              alert('Da ist etwas schiefgelaufen.');
              fetchWarenkorb();
            });
        };   
                              

        const checkAvailability = async () => {
            setLoading(true);
            try {
              const promises = warenkorb.map(async (wk) => {
                const res = await fetch(
                  `/ola?ean=${wk.bestellnummer}&menge=${wk.menge}&sessionId=${user.session_id}`
                );
                const data = await res.json();
                return { ean: wk.bestellnummer, ok: data.ok, liefermenge: data.liefermenge };
              });
          
              const results = await Promise.all(promises);
          
              const availabilityMap = {};
              results.forEach((r) => {
                availabilityMap[r.ean] = { ok: r.ok, liefermenge: r.liefermenge};
              });
          
              setAvailability(availabilityMap);
              setLastChecked(new Date());
            } catch (err) {
              console.error("Error checking availability:", err);
            } finally {
              setLoading(false);
            }
          };


          const totalAmountwNX = warenkorb.reduce(
            (sum, wk) =>
              sum +
              (Number(productinfo[wk.bestellnummer]) || 0) *
              (Number(wk.menge) || 0),
            0
          );
        


        const lieferbarAnzeige = (meldenummer) => {
            if (meldenummer === '000') {
                return 'lieferbar';
            }
        }

        useEffect(() => {
            if (fetchWarenkorb) {
              checkAvailability();
            }
          }, [fetchWarenkorb]);
        
        useEffect(() => {
            if (warenkorb.length > 0) {
              warenkorb.forEach(wk => {
                fetchProductCover(wk.bestellnummer);
              });
            }
          }, [warenkorb]);

          useEffect(() => {
            warenkorb.forEach((wk) => {
              if (!meldetexte[wk.bestellnummer]) {
                fetchProductMeldetext(wk.bestellnummer);
              }
            });
          }, [warenkorb]);

          useEffect(() => {
            warenkorb.forEach((wk) => {
              
                fetchProductDetailsFromNexus(wk.bestellnummer);
              
            });
          }, [warenkorb]);

        

       
      
          const fetchProductCover = async (ean) => {
            try {
              console.log('Fetching cover for EAN:', ean);
              const response = await fetch(`/search?ean=${ean}`);
              if (!response.ok) throw new Error('Fetch failed');
        
              const data = await response.json();
                const mappedDataArray = mapData(data);

                
                const product = mappedDataArray[0]; // Get the first mapped product

                const firstCover = product?.cover?.[0]; // This should now work
              if (firstCover) {
                setCovers(prev => ({
                  ...prev,
                  [ean]: firstCover,
                }));
              }
            } catch (error) {
              console.error(`Error fetching product for EAN ${ean}:`, error);
            }
          };


          const fetchProductMeldetext = async (ean) => {
            try {
              console.log("Fetching meldetext for EAN:", ean);
              const response = await fetch(`/search?ean=${ean}`);
              if (!response.ok) throw new Error("Fetch failed");
          
              const data = await response.json();
              const mappedDataArray = mapData(data);
              const product = mappedDataArray[0];
          
              if (product?.meldetext) {
                setMeldetexte((prev) => ({
                  ...prev,
                  [ean]: product.meldetext,
                }));
              }
            } catch (error) {
              console.error(`Error fetching meldetext for EAN ${ean}:`, error);
            }
          };


          const fetchProductDetailsFromNexus = async (ean) => {
            try {
              console.log('Fetching details for EAN:', ean);
              const response = await fetch(`/search?ean=${ean}`);
              if (!response.ok) throw new Error('Fetch failed');
          
              const data = await response.json();
              const mappedDataArray = mapData(data);
              const product = mappedDataArray[0]; 
          
              if (product?.preis) {
                setProductinfo(prev => ({
                  ...prev,
                  [ean]: product.preis,  
                }));
              }
          
            } catch (error) {
              console.error(`Error fetching product details for EAN ${ean}:`, error);
            }
          };

 
  const deleteCartItem = async (wk_id) => {
    try {
      //local
      //const response = await fetch(`/wk-pos-delete/${wk_id}/${pgid}/${user.session_id}`);
      //server. TODO - rausfinden WARUM
      const response = await fetch(`/api-wk-pos-delete/${wk_id}/${user.session_id}/`);


      const result = await response.json();
      if (result.success) {
        // await fetchWarenkorb(); // Refresh after delete
      } else {
        console.error('Failed to delete item:', result);
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
    await fetchWarenkorb();
  };

        // ⬇️ useEffect just calls fetchWarenkorb once
        useEffect(() => {
          fetchWarenkorb();
        }, [sqlID, callerID, sessionID]);

        useEffect(() => {
          if (warenkorb.length > 0) {
            warenkorb.forEach(wk => {
              fetchProductDetailsFromNexus(wk.bestellnummer);
            });
          }
        }, [warenkorb]);
    



    return (
        
            <div className="mainContentWrapper">

                <div className="contentContainer">
                    

                    
                            <br/>
                            <h4>Warenkorb</h4> 
                        
                        
                            <> 

                         
                                {/* Future automatic shopping cart 
                                    <div className="wkAutoOrder">
                                        <p>Automatisches Versenden des Warenkorbs</p>

                                        <div className='orderOptions'>
                                            <div className="wkAutoOrderNotSelected flexElementContainerRow">
                                                <div className="orderPref">
                                                    Achtung!
                                                    Möchten Sie das <b>automatische Absenden des Warenkorbs</b> aktivieren? 
                                                    <br />
                                                    Hinweis: Sie können die getroffene Entscheidung jederzeit wieder Ändern.
                                                </div>
                                            
                                                <div className="orderPrefSwitch" >
                                                    <div className="radioPrefWK" style={{display: "none"}}>
                                                        <label for='autoSendDefault'>keine Auswahl
                                                            <input 
                                                                type='radio' 
                                                                name='autoSendChoice' 
                                                                id='autoSendYes'  
                                                                
                                                                />
                                                            <span class=""></span>
                                                        </label>
                                                    </div>   
                                                    <div className="radioPrefWK ">
                                                    <div classname="flexElement">Ja</div>
                                                        <div classname="flexElement">
                                                            <input 
                                                                type='radio' 
                                                                name='autoSendChoice' 
                                                                id='autoSendYes'  
                                                                />
                                                            <span class=""></span>
                                                        </div>
                                                    </div>    
                                                    <div className="radioPrefWK">
                                                        <div classname="flexElement">Nein</div>
                                                        <div classname="flexElement">
                                                            <input 
                                                                type='radio' 
                                                                name='autoSendChoice' 
                                                                id='autoSendNo'  
                                                                />
                                                            <span class=""></span>
                                                        </div>    
                                                    </div>
                                                </div>
                                            

                                                
                                            </div>
                                            <div className="wkAutoOrderSelectedYes selectSwitch">
                                                <div className="orderPref">
                                                    Das automatische Absenden des Warenkorbs ist <b>aktiviert</b>.
                                                </div>
                                                
                                                <br />
                                                <div className="orderPrefSwitch">
                                                    <label className="switch">
                                                        <input type="checkbox"/>
                                                        <span className="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="wkAutoOrderSelectedNo selectSwitch">
                                            <div className="orderPref">
                                                    Das automatische Absenden des Warenkorbs ist <b>deaktiviert</b>.
                                                </div>
                                                
                                                <br />
                                                <div className="orderPrefSwitch">
                                                    <label className="switch">
                                                        <input type="checkbox"/>
                                                        <span className="slider round"></span>
                                                    </label>
                                                </div>
                                                <button className="orderPrefSwitch wkSendButton" >Bestellung abschicken</button>
                                                
                                            </div>
                                        </div>    
                                    </div> 

                                    */}

                                    <hr className='hrUmb'/>
                                    <div className='cartHeadline'>
                                        
                                    <div className="cartRow">
    
                                          <div className="cartLeft">
                                            {lastChecked && (
                                              <>Letzte OLA abgerufen um: {lastChecked.toLocaleString()}</>
                                            )}

                                            <button 
                                              className='umbButton'
                                              onClick={checkAvailability} 
                                              disabled={loading || warenkorb.length === 0}
                                            >
                                              {loading ? "Prüfe Verfügbarkeit..." : "OLA aktualisieren"}
                                            </button>
                                          </div>

                                          <div className="cartRight">
                                             <b>
                                              {totalAmountwNX != null
                                                ? `${totalAmountwNX.toFixed(2).replace('.', ',')} €`
                                                : <div className="loader"></div>
                                              }
                                            </b>
                                            <button onClick={handleSendCart} className="umbButton">
                                              <b>Warenkorb absenden</b>
                                            </button>
                                          </div>

                                        </div>  
                                      </div>                              
                                   
                                    <hr className='hrUmb'/>
                                    <div className="wkFlex">
                                        

                                        {warenkorb.map( wk => ( 
                                            <>
                                            
                                            <div class="wkContent wkGridResultsRow" key={wk.wk_id}>
                                                    
                                                    
                                                 <div className='wkColumnOne'>

                                                        <div className='wkCoverTitleBNRmitBZ'>
                                                            
                                                            <div className='wkCoverTitle'>
                                                                <div class="wkCover"> 
                                                                    {covers[wk.bestellnummer] && (
                                                                            <img
                                                                                src={covers[wk.bestellnummer]}
                                                                                alt="Produktcover"
                                                                                style={{ Width: '60px', maxWidth: '60px', height: 'auto', marginTop: '5px', marginBottom: '5px', }}
                                                                            />
                                                                            )}
                                                                    
                                                                </div>
                                                                
                                                                
                                                                
                                                                <div class="wkBestellnummer"> 
                                                                    <i>{wk.bestellnummer} </i>
                                                                    <br />
                                                                    {wk.titel}
                                                                    
                                                                </div>
                                                            </div>    

                                                             <div className="wkBestellzeichen">

                                                              <div className='bzinput'>
                                                                  {editing[wk.wk_id]?.field === "bestellzeichen" ? (
                                                                    <>
                                                                      <input
                                                                        type="text"
                                                                        value={values[wk.wk_id]?.bestellzeichen ?? ""}
                                                                        onChange={e =>
                                                                          handleChange(wk.wk_id, "bestellzeichen", e.target.value)
                                                                        }
                                                                      />
                                                                      <button className='umbButtonIconAgree' onClick={() => saveChange(wk, "bestellzeichen")}>
                                                                        <span className="umbButtonIconAgreeHover"></span>
                                                                      </button>
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {wk.bestellzeichen} (BZ){" "}
                                                                     

                                                                      <button className="umbButtonIconEdit"
                                                                        onClick={() =>
                                                                          toggleEdit(wk.wk_id, "bestellzeichen", wk.bestellzeichen)
                                                                        }
                                                                      > 
                                                                          <span className="umbButtonIconEditHover"></span>
                                                                       </button>
                                                                    </>
                                                                  )}

                                                           
                                                                </div>

                                                                <div className='vminput'>

                                                                  <div className="desktopButtonItem styledCheckbox">
                                                                    <label>
                                                                      {wk.vormerker === "true" ? "Vorgemerkt!" : "Vormerken?"}

                                                                      <input
                                                                        type="checkbox"
                                                                        className="styledCheckbox"
                                                                        checked={wk.vormerker === "true"}
                                                                        disabled={saving?.[wk.wk_id]}
                                                                        onChange={(e) => {
                                                                          const newV = e.target.checked ? "true" : "false";

                                                                          handleChange(wk.wk_id, "vormerker", newV);
                                                                          saveChange(wk, "vormerker", newV);
                                                                        }}
                                                                      />

                                                                      <span className="customCheckbox"></span>
                                                                    </label>
                                                                  </div>

                                                                  </div>        






                                                          
                                                                
                                                               
                                                                </div>
                                                               
                                                                
                                                                <br/>
                                                              
                                                                 

                                                        </div>                
                                                        
                                                </div>    
                                                    
                                                <div className='wkColumnTwo'>  
                                                    <div class="wkPreisAnzeige"> 
                                                        <div className='wkSingleElement'>





                                                        <b>
                                                          {productinfo[wk.bestellnummer] != null
                                                            ? `${Number(productinfo[wk.bestellnummer]).toFixed(2).replace('.', ',')} €`
                                                            : <div className="loader"></div>
                                                          }
                                                        </b>
                                                                  <br/>  
                                                                  <br/>  
                                                                       <button onClick={() => toggleRabatt(wk.wk_id)} className="umbButtonIconInfoRabatt">
                                                                            <span className="iconInfoHoverRabatt">
                                                                            </span>
                                                                        </button>  
                                                                   {openRabattId === wk.wk_id && (
                                                                    <div className="rabatt">
                                                                      Rabatt:  {Number((Number(wk.rabatt) * (2 / 3)).toFixed(2))} % 
                                                                    </div>
                                                              )}                            






                                                        </div>

                                                        



                                                        <div className="wkSingleElement">
                                                          {editing[wk.wk_id]?.field === "menge" ? (
                                                            <>
                                                              <input
                                                                type="number"
                                                                min="1"
                                                                value={values[wk.wk_id]?.menge ?? ""}
                                                                onChange={e =>
                                                                  handleChange(wk.wk_id, "menge", e.target.value)
                                                                }
                                                              />
                                                                <button className='umbButtonIconAgree' onClick={() => saveChange(wk, "menge")}>
                                                                        <span className="umbButtonIconAgreeHover"></span>
                                                                      </button>
                                                              
                                                            </>
                                                          ) : (
                                                            <>
                                                              Menge: {wk.menge}{" "}
                                                             
                                                              
                                                              <button className="umbButtonIconEdit"
                                                                         onClick={() => toggleEdit(wk.wk_id, "menge", wk.menge)}
                                                                      > 
                                                                          <span className="umbButtonIconEditHover"></span>
                                                                       </button>
                                                            </>
                                                          )}

                                                          {saving[wk.wk_id] && <span style={{ marginLeft: 8, color: "orange" }}> Speichern…</span>}
                                                      
                                                        </div>
                                                        <div className='wkSingleElement'>   
                                                            <div className='styledDiv'>
                                                                {availability[wk.bestellnummer]?.ok === 1 && (
                                                                    <div className="lieferbar">Sofort lieferbar</div>
                                                                )}
                                                                {availability[wk.bestellnummer]?.ok === 0 && (
                                                                    <div className="nichtLieferbar">
                                                                        
                                                                        {availability[wk.bestellnummer]?.liefermenge !== null && (
                                                                                <div>
                                                                                Gewünschte Menge nicht lieferbar, verfügbar: {availability[wk.bestellnummer].liefermenge} Stück
                                                                                </div>
                                                                            )}    
                                                                        
                                                                    </div>
                                                                )}
                                                               
                                                            </div>

                                                          
                                                        </div>  
                                                         {/*<div className="wkSingleElement">
                                                                {meldetexte[wk.bestellnummer] || "Keine Meldung"}
                                                            </div>
                                                        
                                                        <div className='wkSingleElement'>
                                                            Rabatt: {wk.rabatt}%                                                                      
                                                        </div>
                                                        */}
                                                        
                                                        
                                                        
                                                    </div>
                                                    <div class="wkButtons">
                                                        <div className='wkSingleElement'>        
                                                                <button className="umbButtonIconDelete" onClick={() => setConfirmDeleteId(wk.wk_id)}> 
                                                                    <span className="iconDeletetHover"></span>
                                                                </button>  
                                                        </div>
                                                              

                                                    </div>
                                                </div>      
                                            </div>
                                              
                                            </>
                                           

                                        ))}    

                                            {confirmDeleteId && (
                                                <div className="overlayBackdrop">
                                                <div className="overlayBox">
                                                    <p>Möchten Sie diesen Artikel wirklich löschen?</p>
                                                    <div className="overlayButtons">
                                                    <button className='umbButton' onClick={() => {
                                                        deleteCartItem(confirmDeleteId);
                                                        setConfirmDeleteId(null); // close overlay
                                                    }}>
                                                        Ja, löschen
                                                    </button>
                                                    <button className='umbButton' onClick={() => setConfirmDeleteId(null)}>
                                                        Abbrechen
                                                    </button>
                                                    </div>
                                                </div>
                                                </div>
                                            )}

                                    </div>  

                                    <div>

                                        
                                    </div>    
                            </>
                        
                                

                    </div>
            </div>
                




    )
}
 
export default Warenkorb;